/**
 * AWS Configuration for the Stinkless Web Application
 * This file contains AWS Amplify configuration settings
 */

// AWS Amplify configuration

// Define the AWS configuration using a simple typed object
// We'll let typescript infer the types rather than explicitly typing with imported types
const awsConfig = {
  Auth: {
    Cognito: {
      // Get the User Pool ID and Client ID from terraform outputs
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_example',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || 'example',
      // Updated auth configuration to meet current Amplify v6 requirements
      loginWith: {
        username: true,
        email: true,
      },
      // Set the AWS region
      region: process.env.REACT_APP_REGION || 'us-east-1',
    }
  },
  // API configuration
  API: {
    REST: {
      stinklessApi: {
        endpoint: process.env.REACT_APP_API_ENDPOINT || 'https://api.example.com',
        region: process.env.REACT_APP_REGION || 'us-east-1',
      }
    }
  },
};

export default awsConfig;